export default "__VITE_ASSET__ClwtasIW__"